import { ReactElement } from 'react';
import CcxComponentProps from '../../../core/CcxComponent';
import AppLogoBrand from './AppLogoBrand';

interface Props extends CcxComponentProps {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppBrandLogoValkey({
    height = 28,
    width = 90,
    testId = 'AppBrandLogoValkey',
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            logo={
                useExtended
                    ? 'vendor-valkey-brand-logo'
                    : 'vendor-valkey-brand-logo'
            }
            height={height}
            width={width}
            size=""
            testId={testId}
        />
    );
}

export default AppBrandLogoValkey;
